function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaginationVue from '@/components/PaginationVue';
import { useCaseMixin } from '@/apps/attributes/mixins/use_case_mixin';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import { envConfig } from '@/js/constants';
import { localPaginationMixin } from '@/mixins/local_pagination';
import ViewAttributeGroupComponent from '@/apps/attributes/components/ViewAttributeGroupComponent';
export default {
  name: 'EditAttributesComponent',
  components: {
    PaginationVue: PaginationVue,
    ViewAttributeGroupComponent: ViewAttributeGroupComponent
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [useCaseMixin, localPaginationMixin],
  data: function data() {
    var perPage = 5;
    return {
      q: '',
      title: 'Add',
      attributesList: [],
      keyTable: 0,
      tab: null,
      encontrado: {
        'found': 0,
        'page': 1,
        'per_page': perPage,
        'q': '',
        'search_time_ms': 0,
        'busqueda': []
      },
      filtro: {
        category: [],
        category_comma: '',
        q: '',
        per_page: perPage,
        page: 1,
        not_null_without_value: true,
        include_search_by_desc: false,
        not_null_min: 0,
        not_null_max: 100,
        include_no_available: true,
        company_code: '0'
      },
      isLoading: false,
      attributes_edit: [],
      partitionsByTable: {},
      valid: true,
      pagination: {
        search: {
          current: 1,
          limit: perPage,
          total: 0
        }
      },
      attribute_groups: [],
      group_selected: null,
      key_detail_group: 1
    };
  },
  created: function created() {
    var _this = this;
    this.getUseCase(this.item.company_code).then(function () {
      console.log(_this.item);
      _this.attributesList = _this.getAttributesList();
      _this.cargarPeriodos();
      _this.getAttributesGroups();
    });
  },
  methods: {
    onSelectAttr: function onSelectAttr(item, add) {
      console.log(item);
      this.addItem(item, add);
      this.cargarPeriodos();
    },
    addAllGroup: function addAllGroup(items, add) {
      var _this2 = this;
      items.forEach(function (item) {
        if (_this2.attributes_edit.filter(function (x) {
          return x.dataset == item.dataset && x.tabla == item.tabla && x.nombre == item.nombre;
        }).length == 0) {
          _this2.addItem(item, add);
        }
      });
      this.cargarPeriodos();
      this.key_detail_group += 1;
    },
    getAttributesGroups: function getAttributesGroups() {
      var _this3 = this;
      UseCasesService.getAttributesGroupsItems(this.companyCode).then(function (response) {
        if (response && response.data) {
          _this3.attribute_groups = response.data.records;
        }
      });
    },
    cargarPeriodos: function cargarPeriodos() {
      var _this4 = this;
      // Se agrupa por categorías y por tipo de dato, para filtrar
      this.categories = _toConsumableArray(new Set(this.attributes_edit.map(function (item) {
        return item.categoria;
      })));
      // Definimos un arreglo con las promesas que hacen el request de las particiones de las tablas
      var partitionRequests = [];
      var periodsByTable = {};
      this.categories.forEach(function (category) {
        var itemsFilter = _this4.attributes_edit.filter(function (item) {
          return item.categoria === category;
        });
        var item = itemsFilter.shift();
        var projectId = item.proyecto;
        var datasetId = item.dataset;
        var tableId = item.tabla;
        var periods = item.filters;
        var request = UseCasesService.getTablePartitionField(projectId, datasetId, tableId);
        partitionRequests.push(request);
        periodsByTable[tableId] = periods.process_date;
      });
      Promise.all(partitionRequests).then(function (values) {
        values.forEach(function (value) {
          var data = value.data.partition_info;
          if (data.table_id) {
            if (data.values) {
              var periodos = [];
              value.data.partition_info.values.map(function (object) {
                var periodo = {
                  id: object,
                  name: object
                };
                periodos.push(periodo);
              });
              value.data.partition_info.values = periodos;
            }
            var table = data.table_id.split('.').pop();
            _this4.partitionsByTable[table] = data;
            _this4.partitionsByTable[table].selection = periodsByTable[table];
          }
        });
      }).finally(function () {
        _this4.keyTable = _this4.keyTable + 1;
      });
    },
    PreselectionData: function PreselectionData() {
      var _this5 = this;
      this.attributes_edit.forEach(function (a) {
        _this5.editedIndex = _this5.encontrado.busqueda.findIndex(function (item) {
          return item.categoria == a.categoria && item.nombre == a.nombre;
        });
        if (_this5.editedIndex >= 0) {
          _this5.editedItem = Object.assign({}, a);
          Object.assign(_this5.encontrado.busqueda[_this5.editedIndex], _this5.editedItem);
        }
      });
    },
    next: function next(page) {
      this.filtro.page = page;
      this.buscarTerminos();
      this.isLoading = false;
    },
    buscarTerminos: function buscarTerminos() {
      var _this6 = this;
      this.isLoading = true;
      this.filtro.company_code = this.companyCode;
      search_engine_service.getBuscadorAtributos(this.filtro).then(function (response) {
        _this6.isLoading = false;
        _this6.encontrado = response;
        _this6.existeBusqueda = _this6.encontrado.found > 0;
        if (_this6.existeBusqueda) {
          _this6.encontrado.busqueda = _this6.encontrado.busqueda.map(function (v) {
            return _objectSpread(_objectSpread({}, v), {}, {
              status: false
            });
          });
          _this6.PreselectionData();
        } else {
          _this6.encontrado.busqueda = [];
        }
      });
    },
    sendToSearch: function sendToSearch() {
      this.encontrado.busqueda = [];
      this.filtro.q = this.q;
      if (this.q == null) {
        this.q = '';
      }
      this.buscarTerminos();
    },
    addAllItem: function addAllItem() {
      var _this7 = this;
      var counter = 0;
      this.encontrado.busqueda.forEach(function (item) {
        if (item.status === true) {
          counter++;
        }
      });
      if (counter < this.encontrado.busqueda.length) {
        this.encontrado.busqueda.forEach(function (item) {
          if (item.status === false) {
            item.status = true;
            _this7.addItem(item);
          }
        });
        this.cargarPeriodos();
      } else {
        this.encontrado.busqueda.forEach(function (item) {
          _this7.removeItem(item);
          item.status = false;
        });
      }
    },
    editItem: function editItem(item) {
      this.editedIndex = this.encontrado.busqueda.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.status) {
        this.editedItem.status = false;
        this.removeItem(item);
      } else {
        this.editedItem.status = true;
        this.addItem(item);
        this.cargarPeriodos();
      }
      Object.assign(this.encontrado.busqueda[this.editedIndex], this.editedItem);
    },
    addItem: function addItem(item) {
      var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!add) {
        this.removeItem(item);
        this.key_detail_group += 1;
        return;
      }
      var category_filter = this.attributes_edit.filter(function (a) {
        return a.categoria == item.categoria;
      });
      var item_filters = {};
      if (category_filter.length > 0) {
        item_filters = category_filter[0].filters;
      }
      var elemento = {
        nombre: item.nombre,
        descripcion: item.descripcion,
        no_nulo: item.no_nulo,
        tipo_dato: item.tipo_dato,
        categoria: item.categoria,
        proyecto: item.proyecto,
        dataset: item.dataset,
        tabla: item.tabla,
        filters: item_filters,
        status: true,
        company_code_usr: this.companyCode
      };
      this.attributes_edit.push(elemento);
    },
    removeItem: function removeItem(item) {
      var index = this.attributes_edit.findIndex(function (a) {
        return a.nombre == item.nombre && a.categoria == item.categoria;
      });
      this.attributes_edit.splice(index, 1);
    },
    getAttributesList: function getAttributesList() {
      if (this.useCase.attribute_count > 0) {
        console.log(this.useCase, 'usecase');
        this.attributes_edit = Object.values(this.useCase.attributes).map(function (item) {
          return {
            nombre: item.attribute_name,
            filters: item.attribute_filters,
            descripcion: item.attribute_description,
            no_nulo: item.attribute_notnull,
            tipo_dato: item.attribute_dtype,
            categoria: item.attribute_category,
            proyecto: item.attribute_project_name,
            dataset: item.attribute_scheme_name,
            tabla: item.attribute_object_name,
            status: true,
            is_external: item.is_external,
            is_partyid: item.is_partyid,
            company_code_usr: item.company_code_usr
          };
        }).filter(function (item) {
          return item.is_external === '0' && item.is_partyid === '0';
        });
      }
      console.log(this.attributes_edit);
      return this.attributes_edit;
    },
    onChangePartitions: function onChangePartitions(table) {
      var _this8 = this;
      this.attributes_edit.forEach(function (element, index) {
        if (element.tabla === table) {
          var field = _this8.partitionsByTable[table].field;
          var selection = _this8.partitionsByTable[table].selection;
          _this8.attributes_edit[index].filters = {};
          _this8.attributes_edit[index].filters["".concat(field)] = selection;
        }
      });
    },
    onUpdate: function onUpdate() {
      var _this9 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      var rDetailAttributes = this.attributes_edit.map(function (item) {
        return {
          attribute_name: item.nombre,
          attribute_object_name: item.tabla,
          attribute_scheme_name: item.dataset,
          attribute_project_name: item.proyecto,
          is_partyid: item.is_partyid || '0',
          is_external: item.is_external || '0',
          attribute_source_id: 3,
          attribute_filters: item.filters ? item.filters : {},
          attribute_description: item.descripcion,
          attribute_category: item.categoria,
          attribute_dtype: item.tipo_dato,
          attribute_notnull: item.no_nulo,
          company_code_usr: item.company_code_usr
        };
      });
      // Como se reemplaza toda la lista, se añaden los atrributos externos (Agregados de tablas de INCA o de tablas propias del Sandbox)
      // const externalAttributes = this.useCase.attributes.filter((item) => item.is_external === '1')
      // rDetailAttributes.push(...externalAttributes)
      var params = {
        company_code_usr: this.companyCode,
        company_name: this.useCase.company_name,
        append: false,
        flag_data_ext: '0',
        applicant: this.userEmail,
        // Solicitude id 4: Solicitud de añadido de atributos
        solicitude_type_id: 4,
        rdetail: rDetailAttributes,
        call_approval_method: false,
        access_deadline_date: this.useCase.access_deadline_date
      };
      var denied = false;
      if (this.item.status_id === 7) {
        denied = true;
      }
      console.log(this.useCase.company_code, this.useCase.id, denied, params, 'atributos internos');
      UseCasesService.updateAttributesUseCase(this.useCase.company_code, this.useCase.id, denied, params).then(function (response) {
        tasks.toast.success('Se está procediendo con la actualización.');
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this9.translate('error_messages.error_general'), _this9.translate('titles.error'));
      }).finally(function () {
        _this9.$emit('close');
      });
    },
    formatItemText: function formatItemText(item) {
      // Combine multiple properties for display
      return "".concat(item.preference_group_name, " - ").concat(item.email);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    rules: function rules() {
      var _this0 = this;
      return {
        period: [function (v) {
          return v && v.length > 0 || _this0.translate('reglas.period');
        }]
      };
    },
    headers: function headers() {
      return [{
        text: this.translate('attributes.search.table_search_list.name'),
        value: 'nombre'
      }, {
        text: this.translate('attributes.search.table_search_list.description'),
        value: 'descripcion'
      }, {
        text: this.translate('attributes.search.table_search_list.category'),
        value: 'categoria'
      }, {
        text: this.translate('attributes.search.table_search_list.data_type'),
        value: 'tipo_dato'
      }, {
        text: this.translate('attributes.search.table_search_list.percentage'),
        value: 'no_nulo'
      }, {
        text: '',
        value: 'actions'
      }];
    },
    headers_group: function headers_group() {
      return [{
        text: this.translate('attributes.group.name'),
        align: 'start',
        sortable: false,
        value: 'preference_group_name'
      }, {
        text: this.translate('attributes.group.definition'),
        align: 'start',
        value: 'group_description'
      }, {
        text: this.translate('attributes.group.quantity'),
        align: 'end',
        value: 'attribute_count'
      }, {
        text: this.translate('attributes.group.owner'),
        align: 'start',
        value: 'email'
      }, {
        text: '',
        align: 'end',
        value: 'actions'
      }];
    }
  })
};